<template>
  <div class="container policy-confirmation" data-test-policy-view-mode="2">
    <div class="row">
      <div class="medium-12 large-6 columns">
        <h1 v-html="modelValue.Title" />
        <span v-html="modelValue.Content" />

        <div class="row">
          <div class="medium-6 columns">
            <a :href="modelValue.SelfServiceLink.Url" class="button large">{{
              modelValue.SelfServiceLink.Text
            }}</a>
          </div>
          <div class="medium-6 columns">
            <a :href="modelValue.LogoutLink.Url" class="button large">{{
              modelValue.LogoutLink.Text
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirmation',
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch('policy/registerEvent', 'policy-view-show-confirmation-page');
  }
};
</script>
